module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Foreword"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Foreword")])])])])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of a fountain outside the home."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of a fountain outside the home.",
      "src": "images/Giannetti_PatinaFarmBook_ExteriorBack-0364.jpg"
    }
  })])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("There are a lot of properties in the world that make a statement. Some are brash, some\n        bold, while others are simply brilliant. The Biltmore in North Carolina is best known for\n        its sheer size as the largest house in America. Hearst Castle in San Simeon can be counted\n        on for its grandiosity and opulence. And think about Monticello for the brilliance of its\n        design, much of it cutting-edge in the late eighteenth century. But, of course, a house\n        doesn’t have to be big to make an impact. Cole Porter’s legendary pied-à-terre at the\n        Waldorf Towers was a master class on chic style in the 1950s, and Vogue editor Diana\n        Vreeland’s apartment, which was ablaze in red chintz—her “garden in hell,” as she put it—was\n        as much a reflection of her as the clothes she wore. As with Vreeland’s home, the common\n        thread with all of these places, big or small, is that they encapsulated their owners’\n        visions, personalities and desires in exacting detail and with a confidence not often seen\n        in design today.  ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("But, right now, on five acres in the heart of the Ojai Valley in California, is a place\n        that has emerged over the past three years as the best case study of confident design\n        married with passion and purpose. It’s not as over-the-top or attention-seeking as some of\n        the aforementioned homes. In fact, it excels in its understatement. Hidden from street view\n        by a bank of white roses, the house and landscape—treated as one—fosters a respect for\n        nature, for space, for light and air. There, everyday moments are celebrated, and that place\n        is Patina Farm. ")])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of ivy-covered walls and a plant-lined path outside the home."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of ivy-covered walls and a plant-lined path outside the home.",
      "src": "images/GIannetti-PatinaFarm2_Exterior-0362.jpg"
    }
  })])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The vision that Brooke and Steve Giannetti have executed celebrates the good life and the\n        art of living well. Artfully designed and executed, the house—like its owners—is a study in\n        unpretentious elegance. Casual, comfortable style blurs the lines between indoors and out.\n        Yet beyond the stalwart stone façade, hand-finished plaster walls and antique tile roof,\n        it’s the spirit of the place that emanates. When you’re at Patina Farm, you feel it through\n        the waft of lavender in the backyard, the sound of crunching pea gravel underfoot on the\n        back terrace, boughs of freshly cut lemons on the kitchen island, the jolly nature of\n        miniature donkeys and Silkie Bantam chickens that have the run of the place. ")])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of the farm at sunset."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of the farm at sunset.",
      "src": "images/DSC_7264_SW_V1.jpg"
    }
  }), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Photography by Brooke Giannetti and Steve Giannetti.")])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("And while the owners didn’t set out to create a Biltmore or Monticello (and why would\n        they?), there are, indeed, similarities: a demand for authentic materials, an unerring eye\n        for quality craftsmanship, a respect for nature and, it goes without saying, the reverence\n        for a beautiful patina, whether it be from the timeworn finish on an antique Swedish table,\n        a tarnished silver box or a thread-bare French bergère. The Giannettis’ quest for the best,\n        as well as living consciously—right now, in the moment—is a testament to their passion for\n        life, which has a lasting impact greater than any brick and mortar structure. That’s the\n        story and legacy of Patina Farm. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e75",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("—Clinton Smith, Editor-in-Chief, "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Veranda")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0